// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Top_wrap__GLtoA","breadcrumbs":"Top_breadcrumbs__AWCeJ","block":"Top_block__JsIDA","head":"Top_head__XvtfY","title":"Top_title__UiGNj","subtitle":"Top_subtitle__WPEy_"};